import { ReactNode } from 'react';

import styles from './FadeIn.module.scss';

const FadeIn: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className={styles.fadeIn}>{children}</div>
);

export default FadeIn;
